import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Data {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-topics',
  templateUrl: './topics.component.html',
  styleUrls: ['./topics.component.css'],
  providers: [HelperService] 
})

export class TopicsComponent implements OnInit {
  // @HostListener('window:beforeunload', ['$event'])
	// unloadHandler(event: Event) {
	// localStorage.removeItem('access_token');
	// localStorage.removeItem('navigateroute');
  // }
  @ViewChild(DataTableDirective)

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas: Data[] = [];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  icon=this.helper.add_icon;
  icon_action='addClick';

  topic_name='';
  summary='';
  all:any=[];
  selected:any=[];
  chapter_id=0;
  topic_id=0;
  syllabus_id;
  gradeid;
  subjectid;
  syllabusname;
  gradename;
  subjectname;
  chaptername;
  subject_id;
  subjectgradeid;
  user_permissions:any=[];
  public Editor = ClassicEditor;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
    this.activatedRouter.params.subscribe((params: Params) => {
      this.chapter_id = params['chap'];
      this.syllabus_id = params['syllabusid'];
      this.gradeid = params['gradeid'];
      //alert(this.gradeid);
      this.subjectid = params['subject_id'];
      this.subject_id = params['sub'];
      this.subjectgradeid = params['subjectgradeid'];
      
    });
  }

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/topic/'+this.chapter_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.datas = data;
        
          this.dtTrigger.next();
        
       
      });
      this.http.get(this.helper.base_url+'http/get/syllabus/'+this.syllabus_id,{ headers: this.headers })
      .subscribe(
         
        (data) => {
          let body = JSON.parse(data['_body']);
          //console.log(body);
          this.syllabusname = body.data[0].name;
          //console.log(this.syllabusname);
          //alert(this.syllabusname);
          // this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
    this.http.get(this.helper.base_url+'http/get/gradedetails/'+this.subjectid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.gradename = body.data[0].name;
        //alert(this.gradename);
        //console.log(this.gradename);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  this.http.get(this.helper.base_url+'http/get/subjectsdetails/'+this.gradeid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.subjectname = body.data[0].name;
        //alert(this.subjectname);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  this.http.get(this.helper.base_url+'http/get/chapter/'+this.chapter_id,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.chaptername = body.data[0].name;
        //console.log(this.chaptername);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  }
  
  editClick(id,name,summary){
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.topic_name=name;
    this.summary=summary;
    this.topic_id=id;
  }
  
  addClick(e){
   
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    this.topic_name="";
    this.summary="";
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  deleteClick(id){
   
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      //this.snackbar.open('Are you sure!', 'Delete', {
        duration: 3000,
        extraClasses:  ['warning-snackbar'],
        verticalPosition:'top'
      }).onAction().subscribe(() => {
        this.http.get(this.helper.base_url+'http/delete/topic/'+id,{ headers: this.headers })
        .subscribe(
           
            (data) => {
              let body = JSON.parse(data['_body']);
              //console.log(body)
              if(body.success == 1)
              {
                this.listClick(null) ;
                this.refresh(false,body.message) ;
              }
              else
              {
                this.snackbar.open(body.message, null, {
                  duration:5000,
                    extraClasses:'error-snackbar',
                    verticalPosition:'top'
                  });
              }
            }, //For Success Response
            err => {console.error(err)} //For Error Response
        );   
      });
  }


 refresh(val=false,msg=''){
   
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["topics/"+this.chapter_id,this.syllabus_id,this.subjectid,this.gradeid,this.subject_id,this.subjectgradeid]));
      
 }
 add_form(addForm: NgForm){this.subjectgradeid
  let body = new FormData();
  
  body.append('name', addForm.value.name);
  body.append('summary', addForm.value.summary);
   this.http.post(this.helper.base_url+'http/add/topic/'+this.chapter_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
      let body = JSON.parse(res['_body']);
      //console.log(body)
       if(body.success == 1)
       {
        this.listClick(null) ;
        this.refresh(false,body.message) ;
       }
       else
       {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
       }

     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 update_form(updateForm: NgForm){
  let id =this.topic_id;
 let body = new FormData();

 body.append('name', updateForm.value.name);
  body.append('summary', updateForm.value.summary);
  // body.append('chapterid',this.chapter_id);

  this.http.post(this.helper.base_url+'http/update/topic/'+id+'/'+this.chapter_id, body,{ headers: this.headers })
  .subscribe(
    (res) => {
      let body = JSON.parse(res['_body']);
      //console.log(body)
       if(body.success == 1)
       {
        this.listClick(null) ;
        this.refresh(false,body.message) ;
       }
       else
       {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
       }
    
    }, //For Success Response
     err => {console.error(err)} //For Error Response);
  );
}
publishClick(id){
    this.http.get(this.helper.base_url+'http/publish/topic/'+id+'/'+this.chapter_id,{ headers: this.headers })
    .subscribe(
       
        (data) => {
          let body = JSON.parse(data['_body']);
      //console.log(body)
       if(body.success == 1)
       {
        this.listClick(null) ;
        this.refresh(false,body.message) ;
       }
       else
       {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
       }
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );   
  //});
}


  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }
  backbtn(){
 
   window.history.back();
 }

}



// WEBPACK FOOTER //
// ./src/app/topics/topics.component.ts